export default __webpack_public_path__ + "static/media/Larsseit-Bold.b4463037.ttf";